import { render, staticRenderFns } from "./ArtBook.vue?vue&type=template&id=b7112ffe&scoped=true&"
import script from "./ArtBook.vue?vue&type=script&lang=js&"
export * from "./ArtBook.vue?vue&type=script&lang=js&"
import style0 from "./ArtBook.vue?vue&type=style&index=0&id=b7112ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7112ffe",
  null
  
)

export default component.exports